import { useFetch } from "../../hooks/useFetch";

export const GetAllOptions = async (query) => {
  try {
    const data = await useFetch(
      `${process.env.REACT_APP_API_URL}/options`,
      query
    );

    for (const item of data.data.data) {
      item["key"] = item.option_uuid;
    }

    return data.data;
  } catch (err) {
    console.log("ERROR: ", err.stack);
  }
};
